import { meetingsActionTypes } from "../constants/meetingsActionTypes"

export const setMeetings=(val)=>{
    return {type:meetingsActionTypes.SET_MEETINGS,payload:val}
}
export const setCalendarMeetings=(val)=>{
    return {type:meetingsActionTypes.SET_CALENDAR_MEETINGS,payload:val}
}
export const setUpcomingCalendarMeetings=(val)=>{
    return {type:meetingsActionTypes.SET_UPCOMING_CALENDAR_MEETINGS,payload:val}
}
export const setCalendarBotMeetings=(val)=>{
    return {type:meetingsActionTypes.SET_CALENDAR_BOT_MEETINGS,payload:val}
}